import { useEffect, useState, RefObject } from "react";

type UseDetectCloseReturn = [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>
];

const useDetectClose = (
  elem: RefObject<HTMLElement>,
  initialState: boolean
): UseDetectCloseReturn => {
  const [isOpen, setIsOpen] = useState<boolean>(initialState);

  useEffect(() => {
    const onClick = (e: MouseEvent): void => {
      if (elem.current !== null && !elem.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      window.addEventListener("click", onClick);
    }

    return () => {
      window.removeEventListener("click", onClick);
    };
  }, [isOpen, elem]);

  return [isOpen, setIsOpen];
};

export default useDetectClose;
